module.exports = {
	"id": "MC",
	"name": "Monaco",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.133308,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.103684,
			"30": null,
			"31": 0.03703,
			"32": 0.014812,
			"33": null,
			"34": null,
			"35": 0.044436,
			"36": 0.007406,
			"37": null,
			"38": 0.014812,
			"39": 0.059248,
			"40": null,
			"41": 0.014812,
			"42": 0.022218,
			"43": 0.25921,
			"44": 0.007406,
			"45": 0.051842,
			"46": 0.022218,
			"47": 0.599886,
			"48": 0.155526,
			"49": 1.784846,
			"50": 0.118496,
			"51": 0.399924,
			"52": 0.70357,
			"53": 22.5883,
			"54": 5.40638,
			"55": 0.066654,
			"56": 0.081466,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.103684,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": 0.022218,
			"26": null,
			"27": 0.007406,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.014812,
			"34": null,
			"35": 0.103684,
			"36": 0.022218,
			"37": 0.014812,
			"38": 0.155526,
			"39": 0.014812,
			"40": 0.014812,
			"41": 0.014812,
			"42": 0.022218,
			"43": 0.11109,
			"44": 0.022218,
			"45": 0.088872,
			"46": 0.022218,
			"47": 0.459172,
			"48": 0.844284,
			"49": 10.494302,
			"50": 0.029624,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": null
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": 0.051842,
			"39": null,
			"40": 0.340676,
			"41": 0.051842,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.051842,
			"6": 0.051842,
			"7": 0.088872,
			"8": 0.570262,
			"9": 1.310862,
			"10": 6.909798,
			"3.1": null,
			"3.2": null,
			"5.1": 0.70357,
			"6.1": 0.866502,
			"7.1": 0.088872,
			"9.1": 5.361944
		},
		"ios_saf": {
			"8": 0,
			"10": 11.5004155579,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.309922891861,
			"8.1-8.4": 0.572569410387,
			"9.0-9.2": 0.273152379267,
			"9.3": 4.16732476062
		},
		"android": {
			"3": 0,
			"4": 0.00521011627907,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.000651264534884,
			"4.1": 0.0187936337209,
			"4.2-4.3": 0.0469840843023,
			"4.4": 0.107737761628,
			"4.4.3-4.4.4": 0.108668139535
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.14812,
			"9": 0.392518,
			"10": 0.199962,
			"11": 7.865172,
			"5.5": null
		},
		"op_mob": {
			"0": 0.00125270645067,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0000347974014076
		},
		"edge": {
			"12": 0.059248,
			"13": 0.548044,
			"14": 1.977402
		},
		"ie_mob": {
			"10": 0.0148390140845,
			"11": 0.0604159859155
		},
		"bb": {
			"7": 0.03633,
			"10": null
		},
		"samsung": {
			"0": 2.441895
		},
		"and_uc": {
			"0": 0.075255
		},
		"op_mini": {
			"0": 0.0168774961479
		},
		"and_chr": {
			"0": 6.312034
		},
		"and_ff": {
			"0": 0.033735
		}
	},
	"total": 99.023575
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/MC.json
 ** module id = 583
 ** module chunks = 0
 **/